export default "__VITE_ASSET__C2VY3xP0__"